<template>
  <div class="global-right-section">
    <div class="overview-stastisc">
      <div class="overview-stastisc-header">
        <p class="title">出勤总数</p>
          <el-date-picker
          class="date"
          v-model="month"
          type="month"
          value-format="yyyy-MM"
          :clearable="false"
          placeholder="选择月">
        </el-date-picker>
      </div>
      <div class="overview-stastisc-count">
        <p>
          <span class="num">{{info.signNum}}</span>&nbsp;人
        </p>
        <!-- <p class="avater-imgs">
          <img v-for="(item, index) in 3" :key="index" :src="item">
        </p> -->
      </div>
      <div class="data-overview-model">
        <p>
          <span>班组签到：</span>
          <span>{{info.offSignNum || 0}}人</span>
        </p>
        <p>
          <span>实名签到：</span>
          <span>{{info.onSignNum || 0}}人</span>
        </p>
      </div>
      <div class="chart" ref="chart">
      </div>
    </div>
    <div class="overview-echart">
      <div class="chart-item" v-for="(item, index) in chartTitles" @click="toDetail(item.menu)" :key="index">
        <p class="title">{{item.name}}</p>
        <div class="chart1" :ref="'chart'+ index"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as echarts from 'echarts'
import { px2vw } from '@/utils/util'
export default {
  name: 'Index',
  data () {
    return {
      month: '',
      info: {},
      chartTitles: [{
        name: '巡查任务',
        menu: '/patrol/taskList',
        color: ['#6291FF', '#7FF2F6', '#FDE598']
      }, {
        name: '问题处理',
        menu: '/patrol/issueList',
        color: ['#00FF00', '#008CFF', '#FF0000']
      }, {
        name: '任务工单',
        menu: '/workPlan/taskOrder',
        color: ['#00FF00', '#008CFF', '#FF0000']
      }, {
        name: '日报填报',
        menu: '/workPlan/dailyReport',
        color: ['#6291FF', '#7FF2F6', '#FDE598']
      }]
    }
  },
  watch: {
    month () {
      this.$nextTick(() => {
        this.loadData()
        this.loadPatrol()
        this.loadOrder()
        this.loadDaily()
      })
    },
    projectId () {
      this.loadData()
      this.loadPatrol()
      this.loadOrder()
      this.loadDaily()
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId || ''
    },
    menuList () {
      return this.$store.getters.rightMenu
    },
    time () {
      return {
        startTime: this.$dayjs(this.month).startOf('month').format('YYYY-MM-DD'),
        endTime: this.$dayjs(this.month).endOf('month').format('YYYY-MM-DD')
      }
    }
  },
  created () {
    this._chart = {}
    this.month = this.$dayjs().format('YYYY-MM')
  },
  destroyed () {
    for (const i in this._chart) {
      this._chart && this._chart[i].dispose()
    }
  },
  methods: {
    loadData () {
      // fag string 1代表过滤无效日期
      this.$axios.get(this.$apis.overview.selectYhAttendanceCountByWeb, {
        fag: '1',
        yearMonth: this.month,
        projectId: this.projectId
      }).then(res => {
        this.info = res
        const y = this.info.list.map(item => item.signNum || 0)
        const x = this.info.list.map(item => this.$dayjs(item.day).format('MM-DD'))
        this.$nextTick(() => {
          this.renderLine(x, y, 'chart')
        })
      })
    },
    loadPatrol () {
      this.$axios.get(this.$apis.overview.selectQualityInspectionProject, {
        ...this.time,
        projectId: this.projectId
      }).then(res => {
        this.$nextTick(() => {
          const data = [{
            name: '巡查任务',
            value: res.taskNum || 0
          },
          {
            name: '已完成',
            value: res.taskOffNum || 0
          },
          {
            name: '未完成',
            value: res.taskOn || 0
          }]
          const data1 = [{
            name: '问题总数',
            value: res.issueNum || 0
          },
          {
            name: '已完成',
            value: res.issueOffNum || 0
          },
          {
            name: '进行中',
            value: res.issueOn || 0
          }]
          this.renderChart('chart0', data, this.chartTitles[0].color, res.taskRate)
          this.renderChart('chart1', data1, this.chartTitles[1].color, res.issueRate)
        })
      })
    },
    loadOrder () {
      this.$axios.get(this.$apis.overview.selectHomeworkOrderProject, {
        ...this.time,
        projectId: this.projectId
      }).then(res => {
        const data = [{
          name: '任务工单',
          value: res.orderNum || 0
        },
        {
          name: '已完成',
          value: res.orderOffNum || 0
        },
        {
          name: '未完成',
          value: res.orderOnNum || 0
        }]
        this.renderChart('chart2', data, this.chartTitles[2].color, res.orderRate)
      })
    },
    loadDaily () {
      this.$axios.get(this.$apis.overview.selectProjectDailySum, {
        yearMonth: this.month,
        projectId: this.projectId
      }).then(res => {
        const data = [{
          name: '填报总数',
          value: res.tbCount || 0
        },
        {
          name: '已填报',
          value: res.ytbCount || 0
        },
        {
          name: '未填报',
          value: res.wtbCount || 0
        }]
        this.renderChart('chart3', data, this.chartTitles[3].color, res.ytbPer)
      })
    },
    hasMenu (menu) {
      let hasM = false
      for (let i = 0; i < this.menuList.length; i++) {
        if (this.menuList[i].url && menu.indexOf(this.menuList[i].url) >= 0) {
          hasM = true
          break
        }
      }
      return hasM
    },
    toDetail (menu, day) {
      if (this.hasMenu(menu)) {
        let parmas = ''
        if (menu !== '/patrol/taskList') {
          parmas = `?month=${this.month}`
          if (day) {
            parmas = parmas + (day ? `&day=${day}` : '')
          }
        }
        this.$router.push(menu + parmas)
      } else {
        this.$message.warning('暂无权限查看详情')
      }
    },
    renderLine (xAxis, yAxis, ref) {
      this._chart[ref] = echarts.init(this.$refs[ref])
      const option = {
        title: {
          text: '每日出勤趋势图',
          textStyle: {
            align: 'center',
            color: '#000000',
            fontSize: 12
          },
          top: px2vw(10),
          left: 'center'
        },
        grid: {
          top: px2vw(60),
          left: px2vw(40),
          bottom: px2vw(40),
          right: 0
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          }
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: false, // 隐藏X轴轴线
            lineStyle: {
              color: '#01FCE3'
            }
          },
          axisTick: {
            show: false // 隐藏X轴刻度
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#000000'
            }
          },
          data: xAxis
        },
        yAxis: {
          name: '人',
          type: 'value',
          minInterval: 1,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#000000'
            }
          }
        },
        series: [
          {
            data: yAxis,
            type: 'line',
            symbol: 'circle', // 标记的图形为实心圆
            symbolSize: px2vw(6), // 标记的大小
            itemStyle: {
              // 折线拐点标志的样式
              color: '#006FFF'
            },
            lineStyle: {
              color: '#35CCFE',
              width: 2
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#3592FE' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(255,255,255,0.78)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              }
            }
          }
        ],
        dataZoom: {
          show: true,
          type: 'slider',
          borderColor: 'transparent',
          backgroundColor: '#D9D9D9',
          fillerColor: '#2275D3',
          handleStyle: {
            opacity: 0
          },
          bottom: px2vw(10),
          height: px2vw(6),
          start: 80,
          end: 100,
          showDetail: false,
          showDataShadow: false,
          brushSelect: false
        }
      }
      this._chart[ref].clear()
      this._chart[ref].setOption(option)
      this._chart[ref].getZr().on('click', (params) => {
        this.clickLine(ref, params)
      })
    },
    clickLine (ref, params) {
      const pointInPixel = [params.offsetX, params.offsetY]
      const pointInGrid = this._chart[ref].convertFromPixel({ seriesIndex: 0 }, pointInPixel)
      // 柱状图-竖向(数据的索引值)
      const day = Math.abs(pointInGrid[0]) + 1
      const menu = '/personservice'
      this.toDetail(menu, day >= 10 ? day : '0' + day)
    },
    renderChart (ref, data, color, per) {
      this._chart[ref] = echarts.init(this.$refs[ref][0])
      const option = {
        tooltip: {
          show: false,
          formatter: '{a} <br/>{b}: {d}%',
          textStyle: {
            fontSize: px2vw(12)
          }
        },
        title: {
          show: true,
          text: per + '%',
          left: '18%',
          top: 'middle',
          textAlign: 'center',
          textStyle: {
            color: '#000000',
            fontSize: px2vw(12),
            fontFamily: 'PingFangSC, PingFang SC'
          }
        },
        legend: {
          orient: 'vertical',
          left: '42%',
          icon: 'circle',
          top: -px2vw(2),
          bottom: 0,
          height: px2vw(140),
          itemWidth: px2vw(4),
          selectedMode: false,
          formatter: (name) => {
            const index = data.findIndex((item) => item.name === name)
            const arr = '{a|' + name + '}{b|:' + data[index].value + '}'
            return arr
          },
          textStyle: {
            fontSize: px2vw(12),
            color: '#000000',
            rich: {
              a: {
                padding: [0, 0, 0, px2vw(2)]
              }
            }
          }
        },
        color: color,
        series: [
          {
            // avoidLabelOverlap: false,
            hoverOffset: 0,
            type: 'pie',
            radius: ['80%', '90%'],
            center: ['20%', '50%'],
            label: {
              show: false,
              position: 'center'
            },
            zlevel: 4,
            itemStyle: {
              normal: {
                borderColor: 'rgba(0, 0, 0, 1)',
                borderWidth: 0,
                color: (value) => {
                  return color[value.dataIndex]
                }
                // shadowColor: 'rgba(0,0,0,0.4)',
                // shadowBlur: 10
              }
            },
            data: data,
            labelLine: {
              show: false
            }
          },
          {
            labelLine: {
              show: false
            },
            itemStyle: {
              opacity: 0.2,
              borderColor: '#ffffff',
              borderWidth: 2
            },
            type: 'pie',
            hoverAnimation: false,
            radius: ['60%', '80%'],
            center: ['20%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            data: data,
            zlevel: -1
          }
        ]
      }
      this._chart[ref].clear()
      this._chart[ref].setOption(option)
    }
  }
}
</script>

<style scoped lang='scss'>
  .global-right-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 6px;
    .overview-stastisc{
      width: 100%;
      background: var(--form-bg-color);
      padding: 10px 6px;
      .overview-stastisc-header{
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        .title{
          width: 116px;
          height: 28px;
          line-height: 28px;
          font-family: YouSheBiaoTiHei;
          font-weight: 400;
          font-size: 18px;
          color: #0F0080;
          background: url('~@/assets/img/overview/icon-title-header.png') 100% 100% no-repeat;
        }
        .date{
          width: 120px !important;
          height: 26px;
          background: #F7F7F7;
          border-radius: 4px;
          border: 1px solid #E1E1E1;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
        }
      }
      .overview-stastisc-count{
        display: flex;
        align-items: center;
        font-family: DFLiJinHeiW8-GB;
        font-weight: 400;
        font-size: 14px;
        color: var(--right-font-color);
        padding-left: 5px;
        .num{
          width: 40px;
          line-height: 27px;
          font-family: DIN-BlackItalic;
          font-weight: 400;
          font-size: 36px;
        }
        .avater-imgs{
          position: relative;
          margin-left: 15px;
          &::after{
            position: absolute;
            right: -25px;
            bottom: 0;
            content: url(~@/assets/img/overview/icon-more.png);
          }
          img{
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background: #ffffff;
          }
        }
      }
      .data-overview-model{
        display: flex;
        margin: 25px 10px 20px 0;
        justify-content: space-between;
        padding-left: 5px;
        p{
          position: relative;
          margin-left: 25px;
          &::before{
            position: absolute;
            left: -25px;
            top: 2px;
          }
          &:nth-of-type(1){
            &::before{
              content: url('~@/assets/img/personSevice/icon-avatar.png');
            }
          }
          &:nth-of-type(2){
            &::before{
              content: url('~@/assets/img/personSevice/icon-realname.png');
            }
          }
        }
      }
      .chart{
        width: 100%;
        height: 190px;
        background: #EFF7FF;
        border-radius: 10px;
        border: 1px solid var(--right-border-color4);
      }
    }

    .overview-echart{
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      width: 100%;
      height: 242px;
      padding: 20px 10px 25px 6px;
      background: var(--form-bg-color);
      margin-top: 6px;
      border-radius: 4px;
      .chart-item{
        width: 53%;
        cursor: pointer;
        &:nth-child(even){
          width: 47%;
        }
        .title{
          position: relative;
          width: 55px;
          height: 24px;
          line-height: 24px;
          background:rgba(129, 112, 255, 0.14);
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          text-align: center;
          margin-bottom: 10px;
          padding-left: 5px;
          &::before{
            position: absolute;
            left: 55px;
            top: 0;
            content: '';
            width: 0;
            height: 0;
            border-bottom: 24px solid transparent;
            border-left: 24px solid rgba(129, 112, 255, 0.14);
            border-radius: 0px 6px 0px 0px;
          }
        }
        .chart1{
          width: 145px;
          height: 58px;
          cursor: pointer;
        }
      }
    }
  }
</style>
